// DEPENDENCIES
import React, { useCallback, useEffect, useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';
import { connect } from 'react-redux';
import { compose } from 'redux';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';
import Card from 'parts/card/Card';

//LOCAL VARIABLES
import { STATES_KEYS } from '../variables';

// MAIN COMPONENT
const VehicleRegistrationForm = compose(connect(({ dealership, user }) => ({ dealership, user })))(
  ({
    // REDUX STATE
    dealership,
    user: { stores }
  }) => {
    // FORMIK
    const { values, setFieldValue } = useFormikContext() || {};
    const { registration_state } = values || {};

    // MEMOS
    const dealerState = useMemo(() => stores.find(store => store.make_dealer_id === dealership), [stores, dealership]);
    // CALLBACKS
    const handleSelect = useCallback(
      e => {
        setFieldValue(`registration_address1`, e.address);
        setFieldValue(`registration_city`, e.city);
        setFieldValue(`registration_state`, e.state);
        setFieldValue(`registration_county`, e.county);
        setFieldValue(`registration_zip_code`, e.zipcode);
      },
      [setFieldValue]
    );
    useEffect(() => {
      if (registration_state !== undefined && registration_state !== '') {
        if (dealerState.dealer_state !== registration_state) setFieldValue('out_of_state_registration', true);
        else if (dealerState.dealer_state === registration_state) setFieldValue('out_of_state_registration', false);
      }
    }, [dealerState.dealer_state, registration_state, setFieldValue]);

    // RENDER
    return (
      <Form.Body>
        <Form.Address label="Registration Address" name="registration_address1" onSelect={handleSelect} required />
        <Form.Control label="City" name="registration_city" required />
        <Form.Select
          name="registration_state"
          label="State"
          lookup="usaStates"
          optionKeys={STATES_KEYS}
          useNone
          required
        />
        <Form.Control label="County" name="registration_county" />
        <Form.Control label="Zip" name="registration_zip_code" required />
        <Form.YesNo label="Out of State Deal" name="out_of_state_registration" numeric={false} disabled />
        <Form.YesNo
          label="Will We Be Using a Third Party Tag and Title Processor (RegUSA, DMV Nationwide, etc)?"
          name="third_party_tag_title"
          numeric={false}
          required
        />
      </Form.Body>
    );
  }
);

// EXPORT
export default function VehicleRegistration(props) {
  return <Card title="Vehicle Registration Address" body={<VehicleRegistrationForm {...props} />} />;
}
